import React, { useEffect, useRef, useState } from "react";
import styles from "./Categories.module.scss";
import { Helmet } from "react-helmet";
import { CategoriesService } from "../../services/categories.service";
import {
  CategorisDataType,
  languagesDataType,
} from "../../interfaces/admin.interface";
import { message, Modal, Popconfirm, Spin } from "antd";
import MainButton from "../../components/shared/MainButton/MainButton";
import Spinner from "../../components/shared/Spinner/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import ErrorMessage from "../../components/shared/ErrorMessage/ErrorMessage";
import { LanguageService } from "../../services/languages.service";
import ChangeLanguage from "../../components/shared/change-language/ChangeLanguage";
import SelectImage from "../../components/shared/select-image/SelectImage";
import { UploadFile } from "antd/es/upload/interface";
import { FaPlus } from "react-icons/fa";
const Categories = () => {
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [categories, setCategories] = useState<CategorisDataType[]>([]);
  const [childCategories, setChildCategories] = useState<
    Record<string, CategorisDataType[]>
  >({});
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [langs, setLangs] = useState<languagesDataType[]>([]);
  const [langCode, setLangCode] = useState("AZ");
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editingCategoryId, setEditingCategoryId] = useState<number | null>(
    null
  );
  const [parentCategoryId, setParentCategoryId] = useState<number | null>(null);
  const [childCategoriesLoading, setChildCategoriesLoading] = useState<
    Record<string, boolean>
  >({});
  const [hoveredRowId, setHoveredRowId] = useState<number | null>(null);
  const [logoFileList, setLogoFileList] = useState<
    { uid: string; name: string; status: UploadFile["status"]; url: string }[]
  >([]);
  const initialCategoryValues = useRef({
    name: "",
    translations: [] as { lang_code: string; name: string }[],
    image_url: "",
  });

  useEffect(() => {
    LanguageService.getAllLanguages().then((response) =>
      setLangs(response?.data)
    );
  }, []);

  const toggleRow = (key: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getChildCategory = (parentId: number) => {
    if (childCategories[parentId]) return;
    setChildCategoriesLoading((prev) => ({
      ...prev,
      [parentId]: true,
    }));
    CategoriesService.getCategoryChild(parentId)
      .then((response) => {
        if (response?.data) {
          setChildCategories((prev) => ({
            ...prev,
            [parentId]: response?.data,
          }));
        }
      })
      .finally(() => {
        setChildCategoriesLoading((prev) => ({
          ...prev,
          [parentId]: false,
        }));
      });
  };

  useEffect(() => {
    setLoading(true);
    CategoriesService.getAllCategoreis()
      .then((response) => {
        if (Array.isArray(response?.data)) {
          setCategories(response?.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const { handleSubmit, values, resetForm, touched, errors, setFieldValue } =
    useFormik({
      initialValues: {
        name: "",
        translations: [] as { lang_code: string; name: string }[],
        image_url: "",
      },
      validationSchema: Yup.object({
        name: Yup.string().required("Kateqoriya adı tələb olunur"),
      }),
      onSubmit: async (values) => {
        try {
          const azTranslation = {
            lang_code: "AZ",
            name: values.name,
          };
          const updatedTranslations = [
            azTranslation,
            ...values.translations.filter((t) => t.lang_code !== "AZ"),
          ];
          const finalValues = {
            ...values,
            translations: updatedTranslations,
          };
          if (isEditing) {
            const isEqual =
              JSON.stringify(values.name) ===
                JSON.stringify(initialCategoryValues.current.name) &&
              JSON.stringify(values.translations) ===
                JSON.stringify(initialCategoryValues.current.translations);
            if (isEqual) {
              message.info("Dəyişiklik edilmədi.");
            } else {
              const response = await CategoriesService.updateCategory({
                ...finalValues,
                id: editingCategoryId,
              });
              if (response.status === 201) {
                message.success("Kateqoriya uğurla yeniləndi!");
                setLoading(true);
                setIsModalVisible(false);
                resetForm();
                setLogoFileList([]);
                const updatedData = await CategoriesService.getAllCategoreis();
                setCategories(
                  updatedData?.data?.map(
                    (item: CategorisDataType, index: number) => ({
                      ...item,
                      key: index + 1,
                    })
                  )
                );

                setChildCategories((prevChildCategories: any) => {
                  const updatedChildCategories = { ...prevChildCategories };
                  const parentId = response?.data?.parent_id;
                  if (updatedChildCategories[parentId]) {
                    updatedChildCategories[parentId] = updatedChildCategories[
                      parentId
                    ].map((child: any) => {
                      if (child.id === response?.data?.id) {
                        return { ...child, name: response?.data?.name };
                      }
                      return child;
                    });
                  }
                  return updatedChildCategories;
                });
              } else {
                message.error(
                  response.errorMessage || "Kateqoriyanı yeniləmək alınmadı."
                );
              }
            }
          } else {
            const newCategory = {
              ...finalValues,
              parent_id: parentCategoryId || null,
            };
            const response = await CategoriesService.addCategory({
              ...finalValues,
              parent_id: parentCategoryId,
            });

            if (response.status === 201) {
              message.success("Kateqoriya uğurla əlavə edildi!");
              setLoading(true);
              setIsModalVisible(false);
              resetForm();
              setLogoFileList([]);
              if (parentCategoryId) {
                setChildCategories((prevChildCategories: any) => ({
                  ...prevChildCategories,
                  [parentCategoryId]: [
                    ...(prevChildCategories[parentCategoryId] || []),
                    { ...newCategory, id: response?.data?.data?.id },
                  ],
                }));
                setChildCategories((prevChildCategories) => {
                  const updatedChildCategories = { ...prevChildCategories };
                  Object.keys(updatedChildCategories).forEach((key) => {
                    updatedChildCategories[key] = updatedChildCategories[
                      key
                    ].map((category) =>
                      category.id === parentCategoryId
                        ? { ...category, is_parent: true }
                        : category
                    );
                  });
                  return updatedChildCategories;
                });
                setCategories((prevCategories) =>
                  prevCategories.map((category) =>
                    category?.id === parentCategoryId
                      ? { ...category, is_parent: true }
                      : category
                  )
                );
                setExpandedRows((prev) => ({
                  ...prev,
                  [parentCategoryId]: true,
                }));
              } else {
                setCategories((prevCategories) => [
                  ...prevCategories,
                  {
                    parent_id: null,
                    name: values.name,
                  } as CategorisDataType,
                ]);
                const updatedData = await CategoriesService.getAllCategoreis();
                setCategories(
                  updatedData?.data?.map(
                    (item: CategorisDataType, index: number) => ({
                      ...item,
                      key: index + 1,
                    })
                  )
                );
              }
            } else {
              message.error(
                response.errorMessage || "Kateqoriya əlavə etmək alınmadı."
              );
            }
          }
        } catch (error: any) {
          message.error(error.message || "Əməliyyat uğursuz oldu.");
        } finally {
          setLoading(false);
        }
      },
    });
  const handleTranslationChange = (value: string) => {
    if (langCode === "AZ") {
      setFieldValue("name", value);
    } else {
      const updatedTranslations = [...values.translations];
      const existingIndex = updatedTranslations.findIndex(
        (t) => t.lang_code === langCode
      );

      if (existingIndex !== -1) {
        updatedTranslations[existingIndex] = {
          ...updatedTranslations[existingIndex],
          name: value,
        };
      } else {
        updatedTranslations.push({ lang_code: langCode, name: value });
      }

      setFieldValue("translations", updatedTranslations);
    }
  };
  const handleDeleteClick = async (record: CategorisDataType) => {
    try {
      const response = await CategoriesService.deleteCategory(record.id);
      if (response.status === 200) {
        setCategories((prevData) =>
          prevData.filter((item) => item.id !== record.id)
        );
        setChildCategories((prevChildCategories) => {
          const updatedChildCategories = { ...prevChildCategories };
          if (updatedChildCategories[record.id]) {
            delete updatedChildCategories[record.id];
          }
          Object.keys(updatedChildCategories).forEach((key) => {
            updatedChildCategories[key] = updatedChildCategories[key].filter(
              (childCategory) => childCategory.id !== record.id
            );
          });
          return updatedChildCategories;
        });
        if (record.parent_id) {
          const response = await CategoriesService.getCategoryChild(
            record.parent_id
          );
          const updatedChildCategories = response?.data;

          setChildCategories((prevChildCategories) => ({
            ...prevChildCategories,
            [record.parent_id]: updatedChildCategories,
          }));
          const isParent = updatedChildCategories.length > 0;
          setCategories((prevCategories) =>
            prevCategories.map((category) =>
              category.id === record.parent_id
                ? { ...category, is_parent: isParent }
                : category
            )
          );
          setExpandedRows((prev) => ({
            ...prev,
            [record.parent_id]: isParent && prev[record.parent_id],
          }));
        }
        message.success("Kateqoriya uğurla silindi!");
      } else {
        message.error(response.errorMessage || "Silmek alinmadi");
      }
    } catch (error) {
      message.error("Kateqoriyanı silmək alınmadı.");
    }
  };

  const handleAddClick = () => {
    setParentCategoryId(null);
    setIsModalVisible(true);
    resetForm();
    setLogoFileList([]);
    setIsEditing(false);
    setLangCode("AZ");
  };
  const handleChildAddClick = (parentId: number) => {
    setParentCategoryId(parentId);
    setIsEditing(false);
    setIsModalVisible(true);
    resetForm();
    setLogoFileList([]);
    setLangCode("AZ");
  };

  const handleEditClick = (category: CategorisDataType) => {
    setEditingCategoryId(category.id);
    setIsEditing(true);
    setIsModalVisible(true);
    setFieldValue("name", category.name);
    setFieldValue("translations", category.translations || []);
    setFieldValue("image_url", (category as any).image_url || "");
    if ((category as any).image_url) {
      setLogoFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: (category as any).image_url,
        },
      ]);
    } else {
      setLogoFileList([]);
    }
    setLangCode("AZ");
    initialCategoryValues.current = {
      name: category.name,
      translations: category.translations || [],
      image_url: (category as any).image_url || "",
    };
  };
  const renderCategories = (parentId: any | null, depth: number = 0) => {
    const parentCategories = categories
      .filter((category) => category.parent_id === parentId)
      .concat(childCategories[parentId] || []);

    if (!parentCategories.length) return null;

    return (
      <table className={styles.nestedTable}>
        <thead>
          <tr>
            <th></th>
            <th>№</th>
            <th>Kateqoriya adı</th>
            <th>
              <div className={styles.settings}>
                <i className="fa-solid fa-gear"></i>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {parentCategories.map((category, index) => {
            const categoryKey = `${category.id}`;
            const isExpanded = expandedRows[categoryKey];
            const isLoading = childCategoriesLoading[category?.id];

            const hasChildren = childCategories[category.id]?.length > 0;
            const showIcon =
              (category.parent_id === null ||
                category.is_parent ||
                hasChildren) &&
              !(
                childCategories[category.id] &&
                childCategories[category.id].length === 0
              );
            const alwaysShowIcon = category.parent_id === null;
            return (
              <React.Fragment key={category.id}>
                <tr
                  onMouseEnter={() => setHoveredRowId(category.id)}
                  onMouseLeave={() => setHoveredRowId(null)}
                >
                  <td>
                    {showIcon || alwaysShowIcon ? (
                      <div className={styles.expand_icons}>
                        <span
                          className={`${styles.toggleIcon} ${
                            isExpanded ? styles.open : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleRow(categoryKey);
                            if (!isExpanded) {
                              getChildCategory(category.id);
                            }
                          }}
                        >
                          {" "}
                          {isExpanded ? "-" : "+"}{" "}
                        </span>
                      </div>
                    ) : (
                      <span></span>
                    )}{" "}
                  </td>

                  <td>{index + 1}</td>
                  <td>{category.name}</td>
                  <td>
                    <div
                      className={`${styles.actions_icons} ${
                        hoveredRowId === category.id ||
                        category.parent_id === null
                          ? styles.visible
                          : styles.unvisible
                      }`}
                    >
                      <div
                        className={styles.edit}
                        onClick={() => handleEditClick(category)}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </div>
                      <Popconfirm
                        title="Bu kateqoriyanı siləcəyinizə əminsiniz?"
                        onConfirm={() => handleDeleteClick(category)}
                        onCancel={() =>
                          message.info("Silinmə əməliyyatı ləğv edildi.")
                        }
                        okText="Bəli"
                        cancelText="Xeyr"
                        placement="topRight"
                      >
                        <div className={styles.delete}>
                          <i className="fa-solid fa-trash"></i>
                        </div>
                      </Popconfirm>
                      <div
                        className={styles.add}
                        onClick={() => handleChildAddClick(category.id)}
                      >
                        <i className="fa-solid fa-square-plus"></i>
                      </div>
                    </div>
                  </td>
                </tr>
                {isExpanded && (
                  <tr>
                    <td colSpan={4}>
                      {isLoading ? (
                        <div
                          style={{ padding: "30px 0", marginLeft: "-120px" }}
                        >
                          <Spin size="large" />
                        </div>
                      ) : (
                        renderCategories(category.id, depth + 1)
                      )}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    );
  };
  return (
    <div id={styles.categories_page}>
      <Helmet>
        <title>1412 | Kateqoriyalar</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <h1 className={styles.page_title}>Kateqoriyalar</h1>
          <div className={styles.categories}>
            <div className={styles.table_head}>
              <MainButton onClick={handleAddClick}>
                <FaPlus size={20} />
              </MainButton>
            </div>
            <div className={styles.categories_wrapper}>
              <div className={styles.category}>
                <table className={styles.mainTable}>
                  <tbody>{renderCategories(null)}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        title={
          isEditing ? "Kateqoriyaya düzəliş edin" : "Yeni Kateqoriya əlavə edin"
        }
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
        style={{ minWidth: "340px" }}
      >
        <form className="modal_form" onSubmit={handleSubmit}>
          <ChangeLanguage
            langCode={langCode}
            setLangCode={setLangCode}
            values={values}
            setFieldValue={setFieldValue}
            langs={langs}
          />
          <div className="form_input">
            <label className="label" htmlFor="name">
              Kateqoriya adı {langCode}
            </label>
            <div className="input_wrapper">
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Kateqoriya adı"
                value={
                  langCode === "AZ"
                    ? values.name
                    : values.translations.find((t) => t.lang_code === langCode)
                        ?.name || ""
                }
                onChange={(e) => handleTranslationChange(e.target.value)}
              />
              <div className="focus_border"></div>
            </div>
            <ErrorMessage error={errors.name} touched={touched.name} />
          </div>

          <div className="form_input">
            <label className="label">Kateqoriya Şəkli</label>
            <SelectImage
              image_name="Şəkil seçin"
              field="image_url"
              setFieldValue={setFieldValue}
              logoFileList={logoFileList}
              setLogoFileList={setLogoFileList}
            />
          </div>

          <MainButton full type="submit">
            {isEditing ? "Redaktə edin" : "Əlavə edin"}
          </MainButton>
        </form>
      </Modal>
    </div>
  );
};

export default Categories;
